export default __webpack_public_path__ + "static/media/platinum.d3e9c647.jpeg";